<template>
<el-dialog :title="dialog.title" :type="dialog.type" :visible.sync="dialogFormVisible" width="30%" append-to-body>
    <div>
        <el-form :model="form" label-width="100px" label-position="left">
            <el-form-item label="信息类型">
                <el-select v-model="form.news_type" placeholder="请选择活动区域">
                    <el-option v-for="(item,index) in dictionary.getPicker('news_type')" :key="index" :label="item.title" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="桌数">
                <el-input type="number" v-model="form.table_amount"></el-input>
            </el-form-item>
            <el-form-item label="餐标">
                <el-input type="number" v-model="form.table_price"></el-input>
            </el-form-item>
            <el-form-item label="宴会类型">
                <el-checkbox-group v-model="form.banquet_type">
                    <el-checkbox label="1">午宴</el-checkbox>
                    <el-checkbox label="2">晚宴</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="form.remark"></el-input>
            </el-form-item>

        </el-form>

    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import dictionary from '@/utils/dictionary'

let form = {
    banquet_type: [],
    year: '',
    month: '',
    day: '',
    remark: '',
    news_type: '',
    table_amount: '',
    table_price: '',
    event_date: '',
    id: ''
};

export default {
    props: {
        item: {},
        parent: {},
    },
    data() {
        return {
            form: Object.assign({}, form),
            formLabelWidth: 80,
            dialogFormVisible: false,
            dialog: {
                title: '',
                visible: false,
                type: ''
            },
            newhallid: '',
            newDay: '',
            newYear: '',
            newMonth: ''

        };
    },
    beforeCreate() {
        this.dictionary = dictionary
    },
    methods: {
        showDialog(hallId, year, month, day, type) {
            this.dialog.title = '添加档期';
            this.dialog.type = 'add';
            this.dialogFormVisible = true;
            let form1 = Object.assign({}, form);
            form1.hall_id = hallId;
            form1.year = year;
            form1.month = month;
            form1.day = day;
            this.form = form1;

        },
        editDilog(item, hallid, type) {
            this.dialogFormVisible = true;
            this.dialog.title = '编辑档期';
            this.dialog.type = 'edit';
            //初始化表单
            let form1 = Object.assign({}, form);
            this.form = Object.assign(form1, item);
            form1.news_type = item.news_type + '';
            let time = new Date(form1.event_date);
            this.newhallid = hallid;
            this.newDay = time.getDate();
            this.newYear = time.getFullYear();
            this.newMonth = time.getMonth() + 1;

        },
        submit(data) {
            let that = this;
            let type = this.dialog.type;
            let query = that.form;
            if (type == 'add') {
                let url = '/api/order.schedule/add';
                that.$post(url, query).then(function (response) {
                    if (response.code != '200') return false;
                    that.$message.success(response.msg);
                    that.$parent.getSchedule();

                });
                that.dialogFormVisible = false;
            } else if (type == "edit") {
                let url = '/api/order.schedule/save';
                that.$post(url, query).then(function (response) {
                    if (response.code != '200') return false;
                    that.$message.success(response.msg);
                    that.parent.showDetailDialog(that.newhallid, that.newYear, that.newMonth, that.newDay)
                });
                that.dialogFormVisible = false;
            }

        }
    }
};
</script>

<style scoped>
.el-dialog__body {
    padding: 30px 20px !important;
}
</style>
